module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABJUlEQVQ4jZXUPShGYRjG8Z/vfJSBQQZFJgsGksGgZGAxm00Wu0VCyWAxSYzCwGBQBoNMTBaLYlKSsin56q7z1uPtxXuueoZzPef8u+/nua9TMde7CpNYRBVWsCeHqjPALpqyz7ZxjZtyMZVYSAChBozlqSQgtSX8kWyvbMhDCb8LdXkgd0XeJw7wmgdyWeTtY61cQAFyjufEa8Z7XsgtThNvHBN5IV/YwFviLaE1DyR0ga3E78MOWvJAQvO4Sp5jkk+KBm8KR9jENDrCLGSnoB4cozPxPnCIe8yiPtl7xFzVUNuPCX/CGQbQnlQb8GHUFHUScRksNdoRvmglziiq+E+Nv+UjypzJYNHeyy/vxc0ux6/gL8XBxurHaNZmd3b9EY8NrH8Dl8My5SjMsB0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-purple.png
// module id = 3mNE
// module chunks = 0